@if (config) {
  <article class="Accordion" [class.Accordion_Card]="config.card">
    <div
      class="Accordion__Header u-flex u-column"
      (click)="toggleContent()"
      [attr.aria-controls]="getContentId(config)"
      [attr.aria-expanded]="!!isOpen"
    >
      <div
        class="Accordion__MainHeader u-flex u-row u-alignCenter"
        [ngClass]="{
          Accordion__MainHeader_IsOpen: isOpen,
          Accordion__MainHeader_IgnoreMargin: config?.ignoreMargin,
          Accordion__MainHeader_HeaderReverse: config.isHeaderReversed,
          Accordion__MainHeader_Subheader: subHeader,
        }"
      >
        @if (config.icon) {
          <icon
            [name]="config.icon"
            [config]="{ fill: 'accordion-icon-color' }"
            role="button"
          >
          </icon>
        } @else {
          <icon
            class="Accordion__Toggle"
            name="chevron_down"
            [class.Accordion__Toggle--Open]="isOpen"
            [config]="{
              fill: 'accordion-toggle-color',
            }"
            role="button"
          >
          </icon>
        }
        @if (!config.customHeader) {
          <zip-button
            class="Accordion__Title"
            [class.Accordion__Title_Bold]="config.isHeaderBold"
            [config]="{ level: 'text', content: config.header }"
          >
          </zip-button>
        }
        @if (config.customHeader) {
          <h6>
            <p data-test-id="customHeader" class="t-ellipsis t-bold">
              {{ config.header }}
            </p>
            @if (config.subHeader) {
              <p data-test-id="customSubHeader" class="t-ellipsis t-alt">
                {{ config.subHeader }}
              </p>
            }
          </h6>
        }
        @if (headerTemplateTitle) {
          <div
            class="Accordion__Title"
            [class.Accordion__Title_Bold]="config.isHeaderBold"
          >
            <ng-container
              *ngTemplateOutlet="headerTemplateTitle"
            ></ng-container>
          </div>
        }
        @if (headerAction) {
          <div
            class="Accordion__Action u-flex u-alignCenter u-justifyEnd u-fillRemaining"
            (click)="onActionClick($event)"
          >
            <!-- Can pass in template or project content -->
            <ng-container *ngTemplateOutlet="headerAction"></ng-container>
            @if (isOpen) {
              <ng-content select="[header-action]"> </ng-content>
            }
          </div>
        }
      </div>
      @if (subHeader) {
        <div
          class="Accordion__Subheader u-flex"
          [class.Accordion__Subheader_Reverse]="config.isHeaderReversed"
        >
          <ng-container *ngTemplateOutlet="subHeader"></ng-container>
        </div>
      }
    </div>
    <section
      class="Accordion__Content"
      [ngClass]="{ 'u-hidden': !isOpen }"
      [attr.id]="getContentId(config)"
      @accordion
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <ng-content></ng-content>
    </section>
  </article>
}
